var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoundAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 10.8332H10.8327V14.9998C10.8327 15.4582 10.4577 15.8332 9.99935 15.8332C9.54102 15.8332 9.16602 15.4582 9.16602 14.9998V10.8332H4.99935C4.54102 10.8332 4.16602 10.4582 4.16602 9.99984C4.16602 9.5415 4.54102 9.1665 4.99935 9.1665H9.16602V4.99984C9.16602 4.5415 9.54102 4.1665 9.99935 4.1665C10.4577 4.1665 10.8327 4.5415 10.8327 4.99984V9.1665H14.9994C15.4577 9.1665 15.8327 9.5415 15.8327 9.99984C15.8327 10.4582 15.4577 10.8332 14.9994 10.8332Z",
    fill: "#7D8697"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundAdd);
export default __webpack_public_path__ + "static/media/icon-round-add.568858e4fea56f7fb555c153bfea67eb.svg";
export { ForwardRef as ReactComponent };